// extracted by mini-css-extract-plugin
export default {"MarginButton":"AutoImporters_MarginButton__Kjume","BoxContainer":"AutoImporters_BoxContainer__Zf4Ng"};